import { ApprovalObjectInfo } from './approval-object-info';
import { Deserialize, inheritSerialization } from 'cerialize';
import { ClientFeeSchedule } from './client-fee-schedule';

@inheritSerialization(ApprovalObjectInfo)
export class ClientFeeScheduleApprovalObjectInfo extends ApprovalObjectInfo {
  get clientFeeSchedule(): ClientFeeSchedule {
    return Deserialize(this.object, ClientFeeSchedule);
  }
}
